import type { AddLiquidityControllerResult } from '@/features/liquidity/useAddLiquidityController'
import { useLiquidityTokenSearch } from '@/features/liquidity/useLiquidityTokenSearch'

import { resolveLiquidityMobileScreen } from './mobile/useLiquidityMobileScreen'

/** Flujo UI Nutrimatic para añadir liquidez: pantalla + picker de tokens. */
export function useLiquidityAddNutrimaticFlow(controller: AddLiquidityControllerResult) {
  const tokenSearch = useLiquidityTokenSearch()
  const screen = resolveLiquidityMobileScreen({
    txHash: controller.txHash,
    walletErrorMessage: controller.walletErrorMessage,
    showConfirm: controller.showConfirm,
    attemptingTxn: controller.attemptingTxn,
  })

  return { screen, tokenSearch }
}

export type LiquidityAddNutrimaticFlow = ReturnType<typeof useLiquidityAddNutrimaticFlow>
